import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService, onResponseErro, onResponseFile } from '../base/base.service';

export interface fileStorageOutput {
  identificador: string
}

@Injectable({
  providedIn: 'root'
})
export class FileStorageService extends BaseService {

  /*
    Informar a rota do Controller correspondente na API
    */
  apiController = "FileStorage";

  /*
  URLS principais
  */
  constructor(public override http: HttpClient) {
    super(http);
  }

  public DownloadFile(identificador: string,
    success: onResponseFile,
    error: onResponseErro = (err) => console.error("erro", err)) {
    return this.download(`download/${identificador}`, success, error);
  };

  public UploadFile(obj): Observable<HttpResponse<fileStorageOutput>> {
    return this.post(`upload`, obj);
  };
}
